import { trimAndAddAsterisk } from '../../utility/QueryUtility';
import { commonDateParamMappings } from '../common/mappings';

export const claimTasksServiceMappings = [
  ...commonDateParamMappings,
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: any) => {
      if (orderBy && order) {
        switch (orderBy) {
          case 'dueDate':
            return `${orderBy},${order}`;
          default:
            return `${orderBy}.keyword,${order}`;
        }
      }
      return null;
    },
  },
  {
    path: 'search',
    transform: ({ search = '' }) =>
      !search ? search : trimAndAddAsterisk(search),
  },
  { path: 'f', paramKey: 'filter' },
];
